import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import style from '../cssmodules/button.module.scss';

function Button({ link, children, modifyer }) {
  return (
    <Link to={link} className={classnames(style.btn, style[modifyer])}>
      {children}
    </Link>
  );
}

Button.defaultProps = {
  modifyer: false,
};

Button.propTypes = {
  link: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
  modifyer: PropTypes.string,
};

export default Button;
